export default "__VITE_ASSET__B6ZC5CkW__"